var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "btn-group" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-default btn-sm",
        attrs: {
          type: "button",
          disabled: _vm.downloadInProgress || _vm.disabled,
          title: (_vm.downloadInProgress
            ? _vm.$t("results.export.downloading")
            : _vm.$t("results.export.csvTooltip")
          ).toLocaleString(),
        },
        on: {
          click: function ($event) {
            return _vm.downloadCsv(false)
          },
        },
      },
      [
        _vm.downloadInProgress
          ? [
              _vm._v(" "),
              _c("span", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" "),
            ]
          : _vm._e(),
        _vm._v("\n\t\t" + _vm._s(_vm.$t("results.export.exportCSV")) + "\n\t"),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-default btn-sm",
        attrs: {
          type: "button",
          disabled: _vm.downloadInProgress || _vm.disabled,
          title: (_vm.downloadInProgress
            ? _vm.$t("results.export.downloading")
            : _vm.$t("results.export.excelTooltip")
          ).toLocaleString(),
        },
        on: {
          click: function ($event) {
            return _vm.downloadCsv(true)
          },
        },
      },
      [
        _vm.downloadInProgress
          ? [
              _vm._v(" "),
              _c("span", { staticClass: "fa fa-spinner fa-spin" }),
              _vm._v(" "),
            ]
          : _vm._e(),
        _vm._v(
          "\n\t\t" + _vm._s(_vm.$t("results.export.exportExcel")) + "\n\t"
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }